var map = {
	"./Homem_olhando_escultura.svg": 9919,
	"./baixar.svg": 6171,
	"./banco.svg": 2707,
	"./camera.svg": 1099,
	"./check.svg": 7486,
	"./copy.svg": 509,
	"./cupom.svg": 6126,
	"./desligar.svg": 4915,
	"./dica.svg": 4735,
	"./editar.svg": 4487,
	"./filtrar.svg": 2136,
	"./floresta.svg": 6326,
	"./formas.svg": 4676,
	"./geppro_seller.svg": 2375,
	"./geppro_sellerBranco.svg": 5400,
	"./ligar.svg": 4435,
	"./lixeira.svg": 4200,
	"./logout.svg": 3180,
	"./loja.svg": 6790,
	"./promocao.svg": 8274,
	"./search.svg": 8246,
	"./trash.svg": 3352,
	"./user.svg": 6975,
	"./userroxo.svg": 7861,
	"./vazio.svg": 9949,
	"./vazio3.svg": 6244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2282;